import React from 'react';

import { Popover as AntDPopover, PopoverProps } from 'antd';
import styled from 'styled-components';

const StyledPopover = styled(AntDPopover)`
  display: flex;
`;

const Popover = (props: PopoverProps) => {
  return <StyledPopover {...props} />;
};

export default Popover;
